// src/Components/SEO/SEO.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const BasicSEO = ({ 
  title = 'Revfer - Professional Networking Platform',
  description = 'Connect with professionals, grow your network, and advance your career with Revfer.',
  keywords = 'professional networking, career growth, business connections',
  image = '/og-image.jpg',
  type = 'website'
}) => {
  const location = useLocation();
  
  // 🔥 THIS SOLVES YOUR CORS ISSUE - Always canonical to www.revfer.com
  const canonicalUrl = `https://www.revfer.com${location.pathname}`;
  const imageUrl = image.startsWith('http') ? image : `https://www.revfer.com${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* 🎯 CANONICAL URL - This fixes duplicate content */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="Revfer" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Revfer Team" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </Helmet>
  );
};

export default BasicSEO;